import {
  format as formatDate,
  parseISO,
  isValid,
} from 'date-fns';

import { DateFormats } from '../enums/date-formats';

interface IDateFormatterProps {
  date?: string | Date;
  format?: DateFormats;
}

export const DateFormatter = (props: IDateFormatterProps) => {
  const { date, format = DateFormats['dd-MMM yyyy'] } = props;
  if (!date) return '';

  const localDate = typeof date === 'string' ? parseISO(date) : date;

  if (isValid(localDate)) return formatDate(localDate, format);

  return `${date}`;
};